import { Link } from "react-router-dom";
import { ArrowLeft, Scale } from "lucide-react";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white" data-testid="terms-of-service-page">
      <div className="max-w-3xl mx-auto px-5 py-10 lg:py-16">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 no-underline mb-6" data-testid="back-link">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>

        <div className="flex items-center gap-3 mb-2">
          <div className="w-11 h-11 rounded-xl bg-[#FF6B00] text-white flex items-center justify-center"><Scale className="h-5 w-5" /></div>
          <div>
            <h1 className="font-['Outfit'] text-3xl sm:text-4xl font-extrabold text-slate-900">Terms of Service</h1>
            <p className="text-xs text-slate-500">Last updated: 25 April 2026</p>
          </div>
        </div>

        <div className="prose prose-sm max-w-none mt-8 text-slate-700 leading-relaxed space-y-5 text-[14.5px]">
          <p>
            These Terms of Service ("Terms") govern your access to and use of the PickNGo platform (website, mobile
            interface, and APIs). By creating an account or placing an order, you agree to be bound by these Terms.
          </p>

          <h2 className="font-['Outfit'] text-xl font-bold text-slate-900">1. Eligibility</h2>
          <p>You must be 18+, an Indian resident or business, and capable of entering into a legally binding contract.</p>

          <h2 className="font-['Outfit'] text-xl font-bold text-slate-900">2. Service Description</h2>
          <p>
            PickNGo is an aggregator platform that connects shippers (customers / B2B businesses) with independent
            delivery agents and external courier partners. We are NOT the carrier — we facilitate the transaction.
            "PickNGo Direct" deliveries are operated by gig-agents on our platform.
          </p>

          <h2 className="font-['Outfit'] text-xl font-bold text-slate-900">3. Pricing &amp; Payments</h2>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>All prices shown include GST. Surge pricing applies during peak windows (visible on the price card).</li>
            <li>Payments are processed via Razorpay. Wallet recharges are non-refundable except in the event of platform error.</li>
            <li>COD orders attract a 5% handling fee. The amount is collected in cash by the agent at delivery.</li>
            <li>Failed deliveries (RTO) are charged at 50% of the original price.</li>
          </ul>

          <h2 className="font-['Outfit'] text-xl font-bold text-slate-900">4. Prohibited Items</h2>
          <p>
            You agree NOT to ship: weapons, ammunition, illegal drugs, hazardous chemicals, perishables without
            insulated packaging, live animals, currency, gold &gt; ₹50,000 value, human remains, or anything illegal
            under Indian law. We reserve the right to refuse, open, or report any suspect package.
          </p>

          <h2 className="font-['Outfit'] text-xl font-bold text-slate-900">5. Damage &amp; Insurance</h2>
          <p>
            We maintain a 1.5% damage provision pool. If a package is verifiably damaged in transit, you may file a
            claim from the delivered-orders page within 48 hours with photos. Approved claims are credited to your
            wallet within 7 working days. Maximum claim per order: ₹2,000 (or declared value, whichever is lower).
          </p>

          <h2 className="font-['Outfit'] text-xl font-bold text-slate-900">6. Agent Responsibilities</h2>
          <p>
            Gig-agents are independent contractors. They commit to pickup-window adherence, package safety, and
            customer politeness. Three same-day cancellations trigger a 7-day suspension. Agents receive a Welcome Kit
            (₹2,380 value) on approval; leaving the platform within 90 days requires returning the kit or paying back
            its value.
          </p>

          <h2 className="font-['Outfit'] text-xl font-bold text-slate-900">7. SLA Guarantee (B2B only)</h2>
          <p>
            For B2B Express orders, if delivery misses the SLA window we automatically credit ₹50 to your wallet. This
            is your sole remedy for delay; consequential damages are excluded.
          </p>

          <h2 className="font-['Outfit'] text-xl font-bold text-slate-900">8. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, PickNGo's total liability for any order is capped at the amount you
            paid for that order, plus any approved damage claim under section 5.
          </p>

          <h2 className="font-['Outfit'] text-xl font-bold text-slate-900">9. Account Termination</h2>
          <p>
            We may suspend or terminate accounts for fraud, abuse, repeated cancellations, payment defaults, or
            shipping prohibited items. You may close your account at any time from settings.
          </p>

          <h2 className="font-['Outfit'] text-xl font-bold text-slate-900">10. Governing Law</h2>
          <p>
            These Terms are governed by the laws of India. Disputes shall be subject to the exclusive jurisdiction of
            courts in Hyderabad, Telangana.
          </p>

          <h2 className="font-['Outfit'] text-xl font-bold text-slate-900">11. Contact</h2>
          <p>
            <b>PickNGo Logistics</b> · <a href="mailto:support@pickngo.co.in" className="text-[#FF6B00] no-underline">support@pickngo.co.in</a> · Khammam, Telangana, India
          </p>
        </div>
      </div>
    </div>
  );
}
